module.exports = "/assets/cda3ce325f4de29e87e1649cee4005e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4Q.png
// module id = 1043
// module chunks = 0